// TODO: rename to price format. it's more common
export const numberWithCommas = (x: any) => {
  x = x ? x.toString() : ''
  const pattern = /(-?\d+)(\d{3})/
  while (pattern.test(x)) x = x.replace(pattern, '$1,$2')
  return x
}
